import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const convertToDataTable = (data: IGetSpeed[]): IGetSpeed[] => {
  const dataTableData: IGetSpeed[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllSpeedsList = async (): Promise<IGetSpeed[]> => {
  const response =  await axiosDefaultApi.get(`/api/Speeds/GetSpeeds`);
  return convertToDataTable(response as unknown as IGetSpeed[]);
};

type QueryFnType = typeof getAllSpeedsList;

type UseGetAllSpeedsListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllSpeedsList = ({ config }: UseGetAllSpeedsListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllSpeedsList'],
    queryFn: () => getAllSpeedsList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};